import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import './styles/index.scss'
import request from '@/utils/request'
import 'vant/lib/index.css'
import {
  Button,
  Field,
  Toast,
  Cell,
  CellGroup,
  NavBar,
  Icon,
  Loading,
  Dialog,
  Form,
  ImagePreview,
  Image as VanImage,
  Uploader,
  List,
  PullRefresh,
  Empty
} from 'vant'
import { getWechatSignature } from './api/common'
import answerImageContainer from './components/answerImageContainer.vue'
// 将封装的请求方法挂载到 Vue 原型上
Vue.prototype.$http = request

// 将 ImagePreview 挂载到 Vue 原型上
Vue.prototype.$imagePreview = ImagePreview
Vue.component('answerImageContainer', answerImageContainer)
// 配置 Toast 默认选项
Toast.setDefaultOptions({
  overlay: true, // 显示背景蒙层
  className: 'custom-toast' // 自定义类名，用于样式调整
})

Vue.use(Toast)
// 注册组件
Vue.use(Button)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(VanImage)
Vue.use(Uploader)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Empty)
// import VConsole from 'vconsole'
// new VConsole()

// 微信验证

if (['serve', 'dev'].includes(process.env.npmLifecycleEvent)) {
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app')
} else {
  getWechatSignature()
    .then((res) => {
      wx.config({
        appId: process.env.VUE_APP_WX_APP_ID,
        signature: res.signature,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        jsApiList: [
          'getLocation',
          'startRecord',
          'stopRecord',
          'playVoice',
          'pauseVoice',
          'stopVoice',
          'translateVoice',
          'onVoicePlayEnd',
          'onVoiceRecordEnd'
        ]
      })
      console.log('appId', process.env.VUE_APP_WX_APP_ID)
      wx.ready(() => {
        new Vue({
          router,
          store,
          render: (h) => h(App)
        }).$mount('#app')
      })
      wx.error((res) => {
        console.log(res, 'wx.error')
        Toast.fail('加载失败 请重试')
      })
    })
    .catch(() => {
      Toast.fail('加载失败 请重试')
    })
}
